import React from 'react';
import * as S from './styles';


export const DashedLines = ({ color }) => {
	return <S.Lines color={color} />;
};
